
























import Vue from "vue"
import {StoryInfo, StoryUtils} from '../lib/story-utils'
import StoryGraph from './StoryGraph.vue'
import request from '../lib/request'
import bus from '../lib/bus'

export default Vue.extend({
  data() {
    return {
      storyName: '',
      storyInfo: {
        source: {type: 'click to set', settings: '{}'},
        sink: {type: 'click to set', settings: '{}'},
        status: 'INIT',
        transforms: [],
        fallback: undefined
      } as StoryInfo
    }
  },

  components: {
    StoryGraph
  },

  methods: {
    onSaveStory(newStoryInfo: StoryInfo) {
      let storyNameCheck = StoryUtils.checkStoryName(this.storyName)
      if (storyNameCheck !== true) {
        alert(storyNameCheck)
        return;
      }

      let storyInfoCheck = StoryUtils.checkStoryInfo(newStoryInfo)
      if (storyInfoCheck !== true) {
        alert(storyInfoCheck)
        return;
      }

      request.createStory(this.storyName, newStoryInfo)
        .then(() => {
          this.$router.push({ name: 'story-runners', params: { storyName: this.storyName } }, () => {
            bus.$emit('notify', `new story ${this.storyName} has been created.`)
          })
        })
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewStory.vue